import React from "react";
import WarningPrompt from "./WarningPrompt";
import { useTranslation } from "../../shared/translation/Translation";

const OrganizerNoRecordingWarning: React.FC = () => {
    const messages = useTranslation();

    const getMessage = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const numerOfSeconds = urlParams.get("secondsLeftToTurnVideoOn");

        const message = messages.organizerNoRecordingWarning.content(numerOfSeconds ?? "");

        return message;
    };

    return <WarningPrompt message={getMessage()}></WarningPrompt>;
};

export default OrganizerNoRecordingWarning;
